export const MAX_AVATARS_DESKTOP = 3;
export const MAX_AVATARS_MOBILE = 5;
